import { render, staticRenderFns } from "./customerLogin.vue?vue&type=template&id=21333e89&"
import script from "./customerLogin.vue?vue&type=script&lang=js&"
export * from "./customerLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports